import { API_PATHS } from "../../paths";
import axios from "axios";
import Industry from "../../Model/IndustryModel";
import { flashMessage } from "../../../utils/flashMessageService";

export async function IndustryCardData() {
  try {
    const token = localStorage.getItem('authToken');
    const response = await axios.get(API_PATHS.industries, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("IndustryCardData response99999:", response);

    const raw = Array.isArray(response?.data?.industries)
      ? response.data.industries
      : Array.isArray(response?.data)
        ? response.data
        : [];

    const formattedData = raw.map((industry) =>
      new Industry(
        industry?._id,
        industry?.industryId,
        industry?.name,
        industry?.imageURL,
        industry?.individuals,
        industry?.location,
        industry?.favoriteCount
      )
    );

    return formattedData;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("fetch industries failed with status 400:", error.response.data);
      flashMessage(`Fetch industries failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error fetching industries:", error);
      flashMessage("Fetch industries failed. Please try again.", { type: "error" });
    }
    throw error;
  }
}